import { HJELPESENTERET_2026_10 } from "./releases/2026-10-07-hjelpesenteret";
import { TIMER_OG_PROSJEKTER_2026_10 } from "./releases/2026-10-27-timer-og-prosjekter";
import type { ReleaseNote } from "./release-types";

/**
 * Alle utrullinger, nyeste først. Ny utrulling: legg til en fil i `releases/`
 * og importer den her. Egen fil av samme grunn som `entries.ts`: hjelp-temaet
 * ankrer filtreringen i `release-registry.ts`, ikke innholdet.
 */
export const RELEASE_NOTES: readonly ReleaseNote[] = [TIMER_OG_PROSJEKTER_2026_10, HJELPESENTERET_2026_10]
  .slice()
  .sort((a, b) => b.date.localeCompare(a.date));
